import "./test-template-button.css";
import {Button, Tooltip} from "antd";
import {useState} from "react";
import {ToastSkin} from "../../../context/ToastContext";
import useUserContext from "../../../hooks/useUserContext";
import useToast from "../../../hooks/useToast";
import {useNavigate} from "react-router-dom";
import useAppContext from "../../../hooks/useAppContext";
import {LabIcon} from "../../../assets/icons/LabIcon";
import {getLocalStorageWithTTL, setLocalStorageWithTTL} from "../../../utils/localStorage";

interface TestTemplateButtonProps {
    title: string;
    content: string;
    language: string;
    flowId: number;
    messageId: number;
}

const TestTemplateButton = ({
    title,
    content,
    language,
    flowId,
    messageId
}: TestTemplateButtonProps) => {
    const [isSendingPreview, setIsSendingPreview] = useState(false);
    const [wasPreviewSent, setWasPreviewSent] = useState(false);
    const { selectedDomain } = useUserContext();
    const { data: { shop }} = useAppContext();
    const { showToast, closeToast } = useToast();
    const navigate = useNavigate();
    const { actions: { sendNotificationPreview } } = useAppContext();
    const previewMessagePhone = shop.data.previewMessagePhoneNumber;

    const requestToSendTestMessage = () => {
        const notificationText = getLocalStorageWithTTL('previewMessage') ? 'This will incur a standard message charge. To avoid blocking multiple test messages, reply to the message before sending more.' : 'This will incur a standard message charge. Do you want to continue?';
        showToast({
            skin: ToastSkin.neutral,
            text: notificationText,
            buttons: [
                { text: 'Send', onClick: sendTestMessage },
                { text: 'Cancel', onClick: closeToast }
            ]
        })
    }

    const sendTestMessage = async () => {
        if(!selectedDomain || isSendingPreview || wasPreviewSent) return;
        setIsSendingPreview(true);
        setLocalStorageWithTTL('previewMessage', 1, 24);
        return sendNotificationPreview(selectedDomain, flowId, messageId).then(response => {
            closeToast();
            if(response && response.status === 200 && !response.data.error) {
                setTimeout(() => {
                    showToast({
                        text: "Test Message was sent to the account's preview number. You should receive it shortly",
                        skin: ToastSkin.approval,
                        displayTime: 5000
                    });
                    setIsSendingPreview(false);
                });
            } else {
                showToast({ skin: ToastSkin.error, text: response.data.error, displayTime: 5000 });
                setIsSendingPreview(false);
            }
        }).catch(error => {
            showToast({ skin: ToastSkin.error, text: error.response.data, displayTime: 5000 });
            setIsSendingPreview(false);
        });
    }

    return (
        <Tooltip title={!previewMessagePhone ? <div>Before sending a preview, you’ll need to set up a verified test number. <span className="link on-dark" onClick={() => navigate('/settings?section=configurations')}>Click here to add one</span>.</div> : (!title || !content || !language) ? "Fill in the title, content, and language to send a preview message." : "Try it out by sending a test message to your WhatsApp number. Standard message charges may apply."}>
            <Button type="default" size="large" className="preview-button" loading={isSendingPreview} onClick={requestToSendTestMessage} icon={<LabIcon width={18} />} disabled={!previewMessagePhone || !title || !content || !language}>Test Message</Button>
        </Tooltip>
    );
}

export default TestTemplateButton;